// import React, { useState } from 'react';
// import { useFormik } from 'formik';
// import * as yup from 'yup';
// import { NuInput } from './Input';
// import { CancelButton, SubmitButton } from './Buttons';
// import axiosInstance from '../../Services/axiosCommon';
// import { useToast } from '../Others/ToastServices';

// const EmailModal = ({ onClose, idd, fetcher, eUrl }) => {
//   const [newEmail, setNewEmail] = useState('');
//   const [newCcEmail, setNewCcEmail] = useState('');
//   const toast = useToast();
//   const [loading, setLoading] = useState(false);
// const [emailError, setEmailError] = useState('');
// const [ccEmailError, setCcEmailError] = useState('');

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: { to: [], cc: [] },
//     validationSchema: yup.object({
//     to: yup.array().min(1, 'At least one recipient email is required.'),
//     // cc: yup.array(),
//   }),
//     onSubmit: async (values, { resetForm }) => {
//       setLoading(true);
//       const payload = {
//         ...values,
//         to: Array.isArray(values.to) ? values.to : [values.to],
//       };

//       axiosInstance.post(`${eUrl}email-report/${idd}`, payload)
//         .then((res) => {
//           toast.open({
//             type: res.data?.status ? 'success' : 'error',
//             message: res.data?.status ? 'Success' : 'Error',
//             description: res.data?.msg || res.data?.error || 'Email send status unknown.',
//           });
//           if (res.data?.status) {
//             resetForm();
//             fetcher();
//             onClose();
//           }
//         })
//         .catch(() => {
//           toast.open({ type: 'error', message: 'Error', description: 'Network error.' });
//         })
//         .finally(() => setLoading(false));
//     },
//   });

//   const handleAddEmail = (field, email, setter) => {
//   if (!email) return;

//   if (formik.values[field].includes(email)) {
//     toast.open({
//       type: 'error',
//       message: 'Already Exist Email',
//       description: `${email} already exists in ${field.toUpperCase()}.`,
//     });
//     return;
//   }

//   formik.setFieldValue(field, [...formik.values[field], email]);
//   setter('');
// };


//   const handleRemoveEmail = (field, email) => {
//     formik.setFieldValue(
//       field,
//       formik.values[field].filter((e) => e !== email)
//     );
//   };

//   return (
//     <div className="animate-scale-in w-full max-w-md max-h-[80vh] overflow-y-auto p-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
//       {/* <h2 className="text-lg text-center font-semibold mb-4">Send Email</h2> */}

//       <form onSubmit={formik.handleSubmit}>
//         {/* To Section */}
//         <div className="mb-6">
//           <div className="flex items-center gap-2">
//           <label className="block text-sm font-semibold text-gray-700 mb-2">To:</label>

//             <NuInput
//               type="email"
//               placeholder="Add recipient email"
//               value={newEmail}
//               onChange={(e) => setNewEmail(e.target.value)}
//               width="w-full"
//             />
//             <button
//               type="button"
//               onClick={() => handleAddEmail('to', newEmail, setNewEmail)}
//               className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded "
//             >
//               +
//             </button>
//           </div>
//           {formik.touched.to && formik.errors.to && (
//   <p className="text-red-500 text-xs ">{formik.errors.to}</p>
// )}

//           {formik.values.to.length > 0 && (
//             <div className="mt-3 bg-gray-100 border rounded p-2 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400">
//               {formik.values.to.map((email, idx) => (
//                 <div
//                   key={`to-${idx}`}
//                   className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm"
//                 >
//                   <span>{email}</span>
//                   <button
//                     type="button"
//                     onClick={() => handleRemoveEmail('to', email)}
//                     className="text-red-500 hover:text-red-700"
//                   >
//                     ×
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* CC Section */}
//         <div className="mb-6">
//           <div className="flex items-center gap-2">
//           <label className="block text-sm font-semibold text-gray-700 mb-2">CC:</label>

//             <NuInput
//               type="email"
//               placeholder="Add CC email"
//               value={newCcEmail}
//               onChange={(e) => setNewCcEmail(e.target.value)}
//               width="w-full"
//             />
//             <button
//               type="button"
//               onClick={() => handleAddEmail('cc', newCcEmail, setNewCcEmail)}
//               className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded "
//             >
//               +
//             </button>
//           </div>
//           {formik.values.cc.length > 0 && (
//             <div className="mt-3 bg-gray-100 border rounded p-2 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400">
//               {formik.values.cc.map((email, idx) => (
//                 <div
//                   key={`cc-${idx}`}
//                   className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm"
//                 >
//                   <span>{email}</span>
//                   <button
//                     type="button"
//                     onClick={() => handleRemoveEmail('cc', email)}
//                     className="text-red-500 hover:text-red-700"
//                   >
//                     ×
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Action Buttons */}
//         <div className="flex justify-end gap-3 mt-6">
//           <CancelButton handleClick={onClose} />
//           <SubmitButton 
//             name="Send"
//             type="submit"
//             isLoading={loading}
//             disabled={formik.values.to.length === 0}
//           />
//         </div>
//       </form>
//     </div>
//   );
// };

// export default EmailModal;



// import React, { useEffect, useState } from 'react';
// import { useFormik } from 'formik';
// import * as yup from 'yup';
// import { FormikSelect, NuInput } from './Input';
// import { CancelButton, SubmitButton } from './Buttons';
// import axiosInstance from '../../Services/axiosCommon';
// import { useToast } from '../Others/ToastServices';

// const EmailModal = ({ onClose, idd, fetcher, eUrl, clientId }) => {
//   const [loading, setLoading] = useState(false);
//   const toast = useToast();
//   const [inspectorOptions, setInspectorOptions] = useState([]);
//   const [newEmail, setNewEmail] = useState('');
//   const [newCcEmail, setNewCcEmail] = useState('');

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: { to: [], cc: [] },
//     validationSchema: yup.object({
//       to: yup.array().min(1, 'At least one recipient email is required.'),
//     }),
//     onSubmit: async (values, { resetForm }) => {
//       setLoading(true);
//       const payload = {
//         ...values,
//         to: Array.isArray(values.to) ? values.to : [values.to],
//         cc: Array.isArray(values.cc) ? values.cc : [values.cc],
//       };

//       try {
//         const res = await axiosInstance.post(`${eUrl}email-report/${idd}`, payload);
//         toast.open({
//           type: res.data?.status ? 'success' : 'error',
//           message: res.data?.status ? 'Success' : 'Error',
//           description: res.data?.msg || res.data?.error || 'Email send status unknown.',
//         });
        
//         if (res.data?.status) {
//           resetForm();
//           fetcher();
//           onClose();
//         }
//       } catch (error) {
//         toast.open({ 
//           type: 'error', 
//           message: 'Error', 
//           description: error.response?.data?.message || 'Network error.' 
//         });
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   // For input field version
//   const handleAddEmail = (field, email, setter) => {
//     if (!email) return;

//     if (formik.values[field].includes(email)) {
//       toast.open({
//         type: 'error',
//         message: 'Already Exist Email',
//         description: `${email} already exists in ${field.toUpperCase()}.`,
//       });
//       return;
//     }

//     formik.setFieldValue(field, [...formik.values[field], email]);
//     setter('');
//   };

//   // For select dropdown version
//   const handleAddEmails = (field, emails) => {
//     if (!emails || emails.length === 0) return;

//     const newEmails = emails
//       .filter(email => email && !formik.values[field].includes(email));
    
//     if (newEmails.length > 0) {
//       formik.setFieldValue(field, [...formik.values[field], ...newEmails]);
//     } else {
//       toast.open({
//         type: 'info',
//         message: 'No new emails',
//         description: 'All selected emails already exist in the list.',
//       });
//     }
//   };

//   const handleRemoveEmail = (field, email) => {
//     formik.setFieldValue(
//       field,
//       formik.values[field].filter((e) => e !== email)
//     );
//   };

//   const fetchClientEmails = (id) => {
//     const fetchId = clientId || id;
//     if (!fetchId) return;

//     axiosInstance
//       .get(`/clients/emails/${fetchId}`)
//       .then((res) => {
//         if (Array.isArray(res.data)) {
//           // Fix: Map the array of strings to the correct format
//           const options = res.data.map((email) => ({
//             value: email,
//             label: email,
//           }));
//           setInspectorOptions(options);
//         } else {
//           console.error('Unexpected API response format', res.data);
//           setInspectorOptions([]);
//         }
//       })
//       .catch((err) => {
//         console.error('Error fetching emails:', err);
//         toast.open({
//           type: 'error',
//           message: 'Error',
//           description: 'Failed to load email options',
//         });
//         setInspectorOptions([]);
//       });
//   };

//   useEffect(() => {
//     if (clientId) {
//       fetchClientEmails(clientId);
//     }
//   }, [idd, clientId]);

//   // Render email input fields when no clientId is available
//   const renderEmailInputFields = () => (
//     <>
//       {/* To Section */}
//       <div className="mb-6">
//         <div className="flex items-center gap-2">
//           <label className="block text-sm font-semibold text-gray-700 mb-2">To:</label>
//           <NuInput
//             type="email"
//             placeholder="Add recipient email"
//             value={newEmail}
//             onChange={(e) => setNewEmail(e.target.value)}
//             width="w-full"
//           />
//           <button
//             type="button"
//             onClick={() => handleAddEmail('to', newEmail, setNewEmail)}
//             className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded"
//           >
//             +
//           </button>
//         </div>
//         {formik.touched.to && formik.errors.to && (
//           <p className="text-red-500 text-xs">{formik.errors.to}</p>
//         )}
//       </div>

//       {/* CC Section */}
//       <div className="mb-6">
//         <div className="flex items-center gap-2">
//           <label className="block text-sm font-semibold text-gray-700 mb-2">CC:</label>
//           <NuInput
//             type="email"
//             placeholder="Add CC email"
//             value={newCcEmail}
//             onChange={(e) => setNewCcEmail(e.target.value)}
//             width="w-full"
//           />
//           <button
//             type="button"
//             onClick={() => handleAddEmail('cc', newCcEmail, setNewCcEmail)}
//             className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded"
//           >
//             +
//           </button>
//         </div>
//       </div>
//     </>
//   );

//   // Render select dropdowns when clientId is available
//   const renderSelectDropdowns = () => (
//     <>
//       {/* To Section */}
//       <div className="mb-6">
//         <div className="flex items-center gap-2">
//           <label className="block text-sm font-semibold text-gray-700 mb-2">To:</label>
//          <FormikSelect
//   name="to"
//   id="to-select"
//   className="text-xs font-medium border w-full h-10 px-3 rounded-[10px] outline-none"
//   placeholder="Select recipient emails"
//   width="w-full"
//   options={inspectorOptions}
//   isMulti
//   onChange={(selectedOptions) => {
//     const selectedEmails = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
//     formik.setFieldValue("to", selectedEmails); // ✅ update Formik state
//   }}
//   value={formik.values.to?.map(email => ({
//     value: email,
//     label: email,
//   })) || []}  // ✅ correctly set selected values
// />

//           <button
//             type="button"
//             onClick={() => document.getElementById('to-select')?.focus()}
//             className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded"
//           >
//             +
//           </button>
//         </div>
//         {formik.touched.to && formik.errors.to && (
//           <p className="text-red-500 text-xs">{formik.errors.to}</p>
//         )}
//       </div>

//       {/* CC Section */}
//       <div className="mb-6">
//         <div className="flex items-center gap-2">
//           <label className="block text-sm font-semibold text-gray-700 mb-2">CC:</label>
//          <FormikSelect
//   name="cc"
//   id="cc-select"
//   className="text-xs font-medium border w-full h-10 px-3 rounded-[10px] outline-none"
//   placeholder="Select CC emails"
//   width="w-full"
//   options={inspectorOptions}
//   isMulti
//   onChange={(selectedOptions) => {
//     const selectedEmails = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
//     formik.setFieldValue("cc", selectedEmails);
//   }}
//   value={formik.values.cc?.map(email => ({
//     value: email,
//     label: email,
//   })) || []}
// />

//           <button
//             type="button"
//             onClick={() => document.getElementById('cc-select')?.focus()}
//             className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded"
//           >
//             +
//           </button>
//         </div>
//       </div>
//     </>
//   );

//   return (
//     <div className="animate-scale-in w-full max-w-md max-h-[80vh] overflow-y-auto p-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
//       <form onSubmit={formik.handleSubmit}>
//         {clientId ? renderSelectDropdowns() : renderEmailInputFields()}

//         {/* Email List Display */}
//         {(formik.values.to.length > 0 || formik.values.cc.length > 0) && (
//           <div className="mt-3 bg-gray-100 border rounded p-2 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400">
//             {/* To emails */}
//             {formik.values.to.length > 0 && (
//               <>
//                 <p className="text-xs font-semibold text-gray-600 mb-1">To:</p>
//                 {formik.values.to.map((email, idx) => (
//                   <div
//                     key={`to-${idx}`}
//                     className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm"
//                   >
//                     <span>{email}</span>
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveEmail('to', email)}
//                       className="text-red-500 hover:text-red-700"
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </>
//             )}

//             {/* CC emails */}
//             {formik.values.cc.length > 0 && (
//               <>
//                 <p className="text-xs font-semibold text-gray-600 mb-1 mt-2">CC:</p>
//                 {formik.values.cc.map((email, idx) => (
//                   <div
//                     key={`cc-${idx}`}
//                     className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm"
//                   >
//                     <span>{email}</span>
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveEmail('cc', email)}
//                       className="text-red-500 hover:text-red-700"
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </>
//             )}
//           </div>
//         )}

//         {/* Action Buttons */}
//         <div className="flex justify-end gap-3 mt-6">
//           <CancelButton handleClick={onClose} />
//           <SubmitButton 
//             name="Send"
//             type="submit"
//             isLoading={loading}
//             disabled={formik.values.to.length === 0 || loading}
//           />
//         </div>
//       </form>
//     </div>
//   );
// };

// export default EmailModal;



import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { FormikSelect, FormikSelectEmail, NuInput } from './Input';
import { CancelButton, SubmitButton } from './Buttons';
import axiosInstance from '../../Services/axiosCommon';
import { useToast } from '../Others/ToastServices';

const EmailModal = ({ onClose, idd, fetcher, eUrl, clientId }) => {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [inspectorOptions, setInspectorOptions] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [newCcEmail, setNewCcEmail] = useState('');

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { to: [], cc: [] },
    validationSchema: yup.object({
      to: yup.array().min(1, 'At least one recipient email is required.'),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      const payload = {
        ...values,
        to: Array.isArray(values.to) ? values.to : [values.to],
        cc: Array.isArray(values.cc) ? values.cc : [values.cc],
      };

      try {
        const res = await axiosInstance.post(`${eUrl}email-report/${idd}`, payload);
        toast.open({
          type: res.data?.status ? 'success' : 'error',
          message: res.data?.status ? 'Success' : 'Error',
          description: res.data?.msg || res.data?.error || 'Email send status unknown.',
        });
        if (res.data?.status) {
          resetForm();
          fetcher();
          onClose();
        }
      } catch (error) {
        toast.open({
          type: 'error',
          message: 'Error',
          description: error.response?.data?.message || 'Network error.',
        });
      } finally {
        setLoading(false);
      }
    },
  });

  // ---------------------- Helpers ------------------------
  const handleAddEmail = (field, email, setter) => {
    if (!email) return;
    if (formik.values[field].includes(email)) {
      toast.open({
        type: 'error',
        message: 'Already Exist Email',
        description: `${email} already exists in ${field.toUpperCase()}.`,
      });
      return;
    }
    formik.setFieldValue(field, [...formik.values[field], email]);
    setter('');
  };

  const handleRemoveEmail = (field, email) => {
    formik.setFieldValue(
      field,
      formik.values[field].filter((e) => e !== email)
    );
  };

  const fetchClientEmails = (id) => {
    const fetchId = clientId || id;
    if (!fetchId) return;

    axiosInstance
      .get(`/clients/emails/${fetchId}`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          const options = res.data.map((email) => ({
            value: email,
            label: email,
          }));
          setInspectorOptions(options);
        } else {
          console.error('Unexpected API response format', res.data);
          setInspectorOptions([]);
        }
      })
      .catch((err) => {
        console.error('Error fetching emails:', err);
        toast.open({
          type: 'error',
          message: 'Error',
          description: 'Failed to load email options',
        });
        setInspectorOptions([]);
      });
  };

  useEffect(() => {
    if (clientId) {
      fetchClientEmails(clientId);
    }
  }, [idd, clientId]);

// ---------------------- State ------------------------
const [showNewEmailInput, setShowNewEmailInput] = useState(false);
const [tempEmail, setTempEmail] = useState("");

// ---------------------- Add New Email ------------------------
const handleAddNewClientEmail = async () => {
  if (!tempEmail) return;

  try {
    await axiosInstance.put(`/clients/emails/${clientId}`, { email: tempEmail });

    toast.open({
      type: "success",
      message: "Email Added",
      description: `${tempEmail} added successfully.`,
    });

    // Refresh dropdown list
    fetchClientEmails(clientId);

    // Reset
    setTempEmail("");
    setShowNewEmailInput(false);
  } catch (error) {
    toast.open({
      type: "error",
      message: "Error",
      description:
        error.response?.data?.message || "Failed to add new email.",
    });
  }
};



  // ---------------------- UI Renders ------------------------
  const renderEmailInputFields = () => (
    <>
      {/* To Section */}
      <div className="mb-6">
        <div className="flex items-center gap-2">
          <label className="block text-sm font-semibold text-gray-700 mb-2">To:</label>
          <NuInput
            type="email"
            placeholder="Add recipient email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            width="w-full"
          />
          <button
            type="button"
            onClick={() => handleAddEmail('to', newEmail, setNewEmail)}
            className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded"
          >
            +
          </button>
        </div>
        {formik.touched.to && formik.errors.to && (
          <p className="text-red-500 text-xs">{formik.errors.to}</p>
        )}
      </div>

      {/* CC Section */}
      <div className="mb-6">
        <div className="flex items-center gap-2">
          <label className="block text-sm font-semibold text-gray-700 mb-2">CC:</label>
          <NuInput
            type="email"
            placeholder="Add CC email"
            value={newCcEmail}
            onChange={(e) => setNewCcEmail(e.target.value)}
            width="w-full"
          />
          <button
            type="button"
            onClick={() => handleAddEmail('cc', newCcEmail, setNewCcEmail)}
            className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded"
          >
            +
          </button>
        </div>
      </div>
    </>
  );

const renderSelectDropdowns = () => (
  <>
    {/* Add New Email */}
    {showNewEmailInput ? (
      <div className="flex items-center gap-2 mb-4 bg-gray-50 p-3 rounded-lg shadow-sm border">
        <NuInput
          type="email"
          placeholder="Enter new email"
          value={tempEmail}
          onChange={(e) => setTempEmail(e.target.value)}
          width="w-full"
        />
        <button
          type="button"
          onClick={handleAddNewClientEmail}
          disabled={!tempEmail}
          className="px-3 py-1 text-xs bg-green-600 text-white rounded-lg shadow hover:bg-green-700 disabled:opacity-50"
        >
          Add
        </button>
        <button
          type="button"
          onClick={() => setShowNewEmailInput(false)}
          className="px-3 py-1 text-xs bg-gray-400 text-white rounded-lg shadow hover:bg-gray-500"
        >
          Cancel
        </button>
      </div>
    ) : (
      <div className="flex justify-end mb-4">
        <button
          type="button"
          onClick={() => setShowNewEmailInput(true)}
          className="flex items-center gap-1 px-3 py-1 text-xs bg-baseColor-primary text-white rounded-lg shadow hover:bg-red-600 transition"
        >
          + Add New Email
        </button>
      </div>
    )}

    {/* To Section */}
    <div className="mb-6">
      <label className="block text-sm font-semibold text-gray-700 mb-2">To:</label>
      <FormikSelectEmail
        name="to"
        Options={inspectorOptions}
        formik={formik}
        isMulti
        placeholder="Select recipient emails"
      />
      {formik.touched.to && formik.errors.to && (
        <p className="text-red-500 text-xs">{formik.errors.to}</p>
      )}
    </div>

    {/* CC Section */}
    <div className="mb-6">
      <label className="block text-sm font-semibold text-gray-700 mb-2">CC:</label>
      <FormikSelectEmail
        name="cc"
        Options={inspectorOptions}
        formik={formik}
        isMulti
        placeholder="Select recipient emails"
      />
    </div>
  </>
);



  return (
    <div className="animate-scale-in w-full max-w-md max-h-[80vh] overflow-y-auto p-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
      <form onSubmit={formik.handleSubmit}>
        {clientId ? renderSelectDropdowns() : renderEmailInputFields()}

        {/* Display selected emails */}
        {(formik.values.to.length > 0 || formik.values.cc.length > 0) && (
          <div className="mt-3 bg-gray-100 border rounded p-2 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400">
            {formik.values.to.length > 0 && (
              <>
                <p className="text-xs font-semibold text-gray-600 mb-1">To:</p>
                {formik.values.to.map((email, idx) => (
                  <div key={`to-${idx}`} className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm">
                    <span>{email}</span>
                    <button
                      type="button"
                      onClick={() => handleRemoveEmail('to', email)}
                      className="text-red-500 hover:text-red-700"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </>
            )}
            {formik.values.cc.length > 0 && (
              <>
                <p className="text-xs font-semibold text-gray-600 mb-1 mt-2">CC:</p>
                {formik.values.cc.map((email, idx) => (
                  <div key={`cc-${idx}`} className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm">
                    <span>{email}</span>
                    <button
                      type="button"
                      onClick={() => handleRemoveEmail('cc', email)}
                      className="text-red-500 hover:text-red-700"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </>
            )}
          </div>
        )}

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-6">
          <CancelButton handleClick={onClose} />
          <SubmitButton
            name="Send"
            type="submit"
            isLoading={loading}
            disabled={formik.values.to.length === 0 || loading}
          />
        </div>
      </form>
    </div>
  );
};

export default EmailModal;
